// src/components/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/lending-mitra-pdf.png';
import { DASHBOARD_URL } from '../config/urls';
import './Navbar.css';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isMenuOpen && !e.target.closest('.nav-container')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  // Check if link is active
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="nav">
      <div className="nav-container">
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-center ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className={isActive('/')}>Home</Link>
          <Link to="/about" className={isActive('/about')}>About Us</Link>
          <Link to="/loans" className={isActive('/loans')}>Loans</Link>
          {/* <Link to="/how-it-works" className={isActive('/how-it-works')}>How It Works</Link> */}
          <Link to="/calculator" className={isActive('/calculator')}>Calculator</Link>
          <Link to="/contact" className={isActive('/contact')}>Contact</Link>
          <a href={DASHBOARD_URL} className="apply-btn-mobile">Apply Now</a>
        </nav>

        <Link to="/" className="nav-logo">
          <img src={logo} alt="Lending Mitra" />
        </Link>

        <div className="nav-right">
          <a href={DASHBOARD_URL} className="apply-btn">Apply Now</a>
        </div>
      </div>
    </header>
  );
}
